import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCjdGTmUFoplUFKnGpSJedlwAPO3iy6CkM",
  authDomain: "rhs-payments.firebaseapp.com",
  projectId: "rhs-payments",
  storageBucket: "rhs-payments.appspot.com",
  messagingSenderId: "69892279638",
  appId: "1:69892279638:web:2a812417f21aefe0aa5af7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);